import CompsEditorContainer from './containers/CompsEditorContainer'

export default CompsEditorContainer
